export default __webpack_public_path__ + "static/allLogos-3bb8dfc50dbef1a5d27e83cdea7c32b4.svg";